export const environment = {
  webSoket: 'https://hit-api.test.creativaconsultores.com',
  apiUrl: 'https://hit-api.test.creativaconsultores.com/api/v1',
  TokenName: 'HIT-user',
  supportId: 53,
  youtubeKey: 'AIzaSyBlLvQJu9SBWVKNyYV0FKGqDAuSKLcJP2w',
  domain: '.creativaconsultores.com',
  baseUrl: 'https://hit-web.test.creativaconsultores.com/',
  path: '/',
};
